export default __webpack_public_path__ + "static/media/C232253.f5642b5f.jpg";